import axios from 'axios';
import type { i18n } from 'i18next';

import type { SupportedLanguages } from 'constants/translations/_types';

export const setLanguage = async (userLanguage: SupportedLanguages, i18n: i18n) => {
  axios.defaults.headers.common['Accept-Language'] = userLanguage;
  await i18n.changeLanguage(userLanguage);
};
